import { VectorImage } from 'ol/layer.js';
import WebGLVectorLayer from 'ol/layer/WebGLVector.js';
//import WebGLVectorLayerRenderer from 'ol/renderer/webgl/VectorLayer.js';

export class VectorLayer extends VectorImage {
	// createRenderer() {
	// 	return new WebGLVectorLayerRenderer(this, { disableHitDetection: false });
	// }
}
